import 'bulmaswatch/minty/bulmaswatch.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReactDOM from 'react-dom';
import App from './components/app/app';

ReactDOM.render(<App />, document.querySelector('#root'));
